export default __webpack_public_path__ + "static/media/two.a99dfb40.svg";